export default () => {
  const cont = document.querySelector(".header");

  cont ? bigSearch() : false;
  

  function bigSearch() {
    const searchBtn = cont.querySelector(".header-open-search");
    const searchBlock = cont.querySelector(".big-search-wrapper");
    const searchClose = cont.querySelector(".close-search");
    const searchBtnMobile = cont.querySelector(".header-mobile-menu-open");
    const block = document.querySelector(".header-right");

    searchBtn.addEventListener("click", () => {
      searchBlock.classList.toggle("show");
    });
    searchClose.addEventListener("click", () => {
      searchBlock.classList.toggle("show");
      block.classList.toggle("show");
    });
    searchBtnMobile.addEventListener("click", () => {
      searchBlock.classList.toggle("show");
    });
  }

  if( window.innerWidth <= 768 ){
    cont ? openSubmenu() : false;

    function openSubmenu() {
      const listItems = document.querySelectorAll(".header-list-item");
      const headerList = document.querySelector(".header-list");
      const subMenu = document.querySelector(".submenu");
      listItems.forEach((item) => {
        const dots = item.querySelector(".dots-wrapper");
        const link = item.querySelector(".header-item-link");
        const submenu = item.querySelector(".submenu");
        const dotBack = item.querySelectorAll(".dots-wrapper-back");
  
        if (dots) {
          dots.addEventListener("click", () => {
            headerList.classList.toggle("submenu-open");
            submenu.classList.toggle("current");
          });
          link.addEventListener("click", () => {
            headerList.classList.toggle("submenu-open");
            submenu.classList.toggle("current");
          });
          dotBack.forEach((dot) => {
            dot.addEventListener("click", () => {
              headerList.classList.toggle("submenu-open");
              submenu.classList.toggle("current");
            });
          });
        }
      });
    }
  }
  
  
};
